import { PartialShipmentPlanningSplitView } from "../PartialShipmentPlanningSplitView";
import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentPlanning extends Layout {
    layoutPartialShipmentPlanningSplitView: PartialShipmentPlanningSplitView;
    sourceManifestProfile: DataSource;
    tabProfile: Tab;
    tabsetManifestPlanningProfiles: Tabset;
}
